// extracted by mini-css-extract-plugin
export default {"title":"entry-data-pembeli_title__3dYPO","input-wrapper":"entry-data-pembeli_input-wrapper__xXwtp"};